import apiUseCases from "@src/cloud-connect/api";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import { i18n } from "@src/i18n/i18n";
import store from "@src/reducers/store";

export const getMyBlueprintLibraryUseCase = async () => {
  try {
    const state = store.getState();
    const language = state.yourSlice.language;
    const namespace = state.yourSlice.authContext?.customerNamespace;

    const texts = {
      blueprintLibraryUnexpectedError: i18n(
        "modules.snackbarNotifications.blueprintLibraryUnexpectedError",
        language,
      ),
    };

    if (!namespace) {
      errorSnackbar(texts.blueprintLibraryUnexpectedError);
      return [];
    }

    const response = await apiUseCases.getMyBlueprintLibrary(namespace);

    if (response.status === 200) {
      return response.body;
    } else if (response.status === 404) {
      errorSnackbar(response.body.message);
      return [];
    } else {
      errorSnackbar(texts.blueprintLibraryUnexpectedError);
      return [];
    }
  } catch (error) {
    const language = store.getState().yourSlice.language;
    const texts = {
      blueprintLibraryUnexpectedError: i18n(
        "modules.snackbarNotifications.blueprintLibraryUnexpectedError",
        language,
      ),
    };

    const parsedError = parseAxiosApiError(
      error,
      texts.blueprintLibraryUnexpectedError,
    );
    errorSnackbar(parsedError.message || texts.blueprintLibraryUnexpectedError);
    return [];
  }
};
